export default {
  mingInfo: { method: 'get', url: '/api/v1/mining/info' }, //获取入金挖矿信息
  lpInfo: { method: 'get', url: '/api/v1/lp/info' }, //获取LP挖矿信息
  miningPay: { method: 'post', url: '/api/v1/mining/getOrder' }, //获取挖矿支付订单
  reinvestPay: { method: 'post', url: '/api/v1/mining/reinvestGetOrder' }, //获取复投支付订单
  lpPay: { method: 'post', url: '/api/v1/lp/getOrder' }, //获取LP挖矿支付订单
  incomeList: { method: 'get', url: '/api/v1/user/incomeList' }, //收益记录
  doWithdraw: { method: 'post', url: '/api/v1/withdraw/apply' }, //提现
  withdrawList: { method: 'get', url: '/api/v1/withdraw/list' }, //提现记录
  doExchange: { method: 'post', url: '/api/v1/exchange/index' }, //兑换
  exchangeList: { method: 'get', url: '/api/v1/exchange/list' }, //兑换记录
  miningOrderList: { method: 'get', url: '/api/v1/mining/miningOrder' }, //入金挖矿订单列表
  lpOrderList: { method: 'get', url: '/api/v1/lp/lpOrder' }, //LP挖矿订单列表
  doTransfer: { method: 'post', url: '/api/v1/transfer/index' }, //转账互转
  transferList: { method: 'get', url: '/api/v1/transfer/list' }, //转账记录
  peerTransfer: { method: 'post', url: '/api/v1/peer/transfer' }, //门票互转
  peerTransferList: { method: 'get', url: '/api/v1/peer/transferList' }, //门票互转记录
  peerInfo: { method: 'get', url: '/api/v1/peer/info' }, //互助首页信息
  peerActivate: { method: 'post', url: '/api/v1/peer/activate' }, //互助激活账户
  peerSubscribe: { method: 'post', url: '/api/v1/peer/subscribe' }, //互助认购
  peerOrderList: { method: 'get', url: '/api/v1/peer/orderList' }, //互助订单列表
  peerReceiveList: { method: 'get', url: '/api/v1/peer/receiveList' }, //互助待领取记录
  peerReceive: { method: 'post', url: '/api/v1/peer/receive' }, //互助一键领取
  peerIncomeList: { method: 'get', url: '/api/v1/peer/incomeList' } //互助收益记录
}
